module.exports = __webpack_public_path__ + "img/mobile-background.e84a0211.png";